import { closeDialogEvent } from '@bifrost/web-components';
const navigateBack = () => {
    window.bifrostSentry?.captureMessage('Android back navigation', 'log');
    const isDialogOpen = document.querySelector('div[role="dialog"][data-state="open"]');
    const isMenuOpen = document.querySelector('div[role="menu"][data-state="open"');
    if (isDialogOpen || isMenuOpen) {
        window.dispatchEvent(new CustomEvent(closeDialogEvent));
        return;
    }
    const isDeviceOnboarding = location.pathname.startsWith('/devices/new');
    if (isDeviceOnboarding) {
        window.dispatchEvent(new CustomEvent('bifrost-devices:exit-onboarding'));
        return;
    }
    window.history.back();
};
window.bifrostWeb = {
    ...window.bifrostWeb,
    capabilities: [
        'scanDeviceQRCode',
        'connectToDevice',
        'getWiFiNetworks',
        'configureDevice',
        'finishOnboarding',
        'backNavigation',
    ],
    navigate: url => window.history.pushState({}, '', url),
    getIsMobile: () => !!window.bifrostNative,
    navigateBack,
};
